export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.22-1349.18",
  commitId: "9cb239d7a5a9bbb691dd3085968eec68af1753f7",
  commitTime: "2026-04-22T13:49:18.000Z",
});
